/**
 * SSE State - Default Implementation
 *
 * Provides the default implementation of ISseState.
 * Uses Signal.State for reactive connection status tracking.
 */

import { Signal } from "@lit-labs/signals";
import type { ISseState, SseConnectionStatus } from "./types";

export class SseState implements ISseState {
  readonly status = new Signal.State<SseConnectionStatus>("disconnected");
  readonly hasSession = new Signal.State<boolean>(false);
}
